'use strict';
import * as $j_$002dx3949f73d895080ace64f0b4279cedc5c78e966a3 from "./-x3949f73d895080ace64f0b4279cedc5c78e966a3.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$58() {
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$58 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$58 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$58.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$58.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$58;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$58() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$58 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$58 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$58.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$58.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$58.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$58.prototype.apply__Lsttp_tapir_Schema = (function() {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3ftapir$package$();
  var \u03b4proxy31 = $j_$002dx3949f73d895080ace64f0b4279cedc5c78e966a3.$m_Lapp_data_types\uff3fout\uff3fof\uff3fstock\uff3fmediation\uff3freport$package$OutOfStockMedicationReportAdditionalNotes$();
  return $x_1.newTypeSchema__Lyantl_INewtype__Lsttp_tapir_Schema__Lsttp_tapir_Schema(\u03b4proxy31, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForString);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$58.prototype.apply__O = (function() {
  return this.apply__Lsttp_tapir_Schema();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$58 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$58, "app.api.DrugRequestsAcceptedListItem$$anon$58", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$58: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$58 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$58 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$58.js.map
